export default "__VITE_ASSET__05ff3008__"